import { FC } from "react";

import { StepManualMeasurements } from "@/components/Procedures/Checklist/Step/StepManualMeasurements";
import { StepMeasurementListeners } from "@/components/Procedures/Checklist/Step/StepMeasurementListeners";
import { IStepMeasurements } from "@/components/Procedures/Checklist/utils/Types";
import { CheckpointType } from "@/components/Procedures/Types/ManualChecklistTypes";

export const StepMeasurements: FC<IStepMeasurements> = (props) => {
	if (props.step?.CheckpointType === CheckpointType.ManualMeasurement) {
		return <StepManualMeasurements {...props} />;
	}

	return <StepMeasurementListeners {...props} />;
};
